import { NgModule } from '@angular/core'
import { PatientNamePipe } from './patient-name.pipe'

@NgModule({
  declarations: [PatientNamePipe],
  imports: [],
  exports: [PatientNamePipe]
})
export class CommonServicesModule {}
